import(/* webpackMode: "eager" */ "/home/ubuntu/routerbench_new/apps/playground/src/app/global-error.tsx");
